import { createApp } from 'vue'
import App from './App.vue'
import Quasar from 'quasar/src/vue-plugin.js';
import router from './router'
import quasarUserOptions from './quasar-user-options'
import store from './vuex/store';



createApp(App).use(Quasar, quasarUserOptions).use(router).use(store).mount('#app')
